import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-b2bteams-confirmation',
  templateUrl: './b2bteams-confirmation.component.html',
  styleUrls: ['./b2bteams-confirmation.component.scss']
})
export class B2bteamsConfirmationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
